import React from "react";
import NoResultSvg from "./no-result.svg";
import { NoResultWrapper, ImageWrapper, ButtonWrapper } from "./NoResult.style";
import Button from "../Button/Button";
// import { ArrowPrev } from '../AllSvgIcon';

type NoResultProps = {
  id?: string;
  onClick?: () => void;
  hideButton?: boolean;
  style?: any;
  message?: string;
  buttonText?: string;
};

const NoResult: React.FC<NoResultProps> = ({
  id,
  onClick,
  hideButton = false,
  style,
  message,
  buttonText,
}) => {
  let textToDisplay = "Sorry, No result found :(";
  if (message) {
    textToDisplay = message;
  }

  return (
    <NoResultWrapper id={id} style={style}>
      <h3>{textToDisplay}</h3>

      <ImageWrapper>
        <img src={NoResultSvg} alt="No Result" />
      </ImageWrapper>

      {!hideButton ? (
        <ButtonWrapper>
          <div onClick={onClick}>
            <Button>{buttonText}</Button>
          </div>
        </ButtonWrapper>
      ) : null}
    </NoResultWrapper>
  );
};

export default NoResult;
